<template>
    <div v-if="selected_group">
        <b-row class="align-items-center">
            <b-col cols="6">
                <b-button variant="link" @click="emitEvent('go-back-to-chat-main')" class="px-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6L14 18Z"/></svg>
                    Back
                </b-button>
            </b-col>
            <!-- <b-col cols="6" v-if="selected_group && selected_group.group_channel_type !== 'PUBLIC'">
                <b-avatar-group size="28px" class="float-right mr-4">
                    <el-tooltip :content="participant.participant_fullname" v-for="(participant, index) in selected_group.group_participants" :key="index">
                        <b-avatar  :text="_gHlp.formatInitials(participant.participant_fullname)"></b-avatar>
                    </el-tooltip>
                </b-avatar-group>
            </b-col> -->
        </b-row>
        <b-row class="align-items-center mb-3">
            <b-col cols="6">
                <h3 class="mb-0 font-weight-500">
									<el-popover placement="right-end" trigger="hover">
										<p>
											<strong>{{ (selected_group.group_channel_type == 'PUBLIC') ? 'Group Message' : 'Private Message' }}</strong>
											<small class="d-block">
												Created By {{ getGroupCreator(selected_group) }} at {{ selected_group.group_created_date | dateTimeDynamicFormat('DD/MM/YYYY h:mm A') }}
											</small>
										</p>
										<el-button slot="reference" type="warning" icon="fa fa-users" size="mini" plain round v-if="(selected_group.group_channel_type == 'PUBLIC')"></el-button>
										<el-button slot="reference" type="info" icon="fa fa-user" size="mini" plain round v-else></el-button>
									</el-popover>
									{{ getGroupName(selected_group) }}
								</h3>
            </b-col>
            <b-col cols="6" class="text-right text-primary">
                <b-button variant="link" @click="$refs.search_message_drawer.viewSearchMessageDrawer()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path fill="currentColor" d="M416 208c0 45.9-14.9 88.3-40 122.7l126.6 126.7c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                    Search
                </b-button>
            </b-col>
        </b-row>
        <b-row class="align-items-center mb-3 replies-to" v-if="!isReadonly">
            <b-col cols="12" v-if="replying_to">
                <b-alert show dismissible class="text-dark" @dismissed="resetReply">
                    Reply to <span class="font-weight-600">{{ replying_to.message_participant.participant_fullname }} :</span>
                    <RichTextRenderer :content="replying_to.message_content" />
                </b-alert>
            </b-col>
            <b-col cols="12">
                <Tiptap v-model="content" />
            </b-col>
        </b-row>
				<b-row class="align-items-center mb-3" v-else>
            <b-col cols="12">
							<div class="alert alert-danger">
								You are currently in read only mode because you are not a member of the chat room
							</div>
            </b-col>
        </b-row>
        <div v-if="messages">
            <div v-for="(message, index) in messages" :key="index">
                <div class="border-top px-3 py-2" v-if="message.message_is_info != 1">
                    <div class="d-flex align-items-start messenger-header position-relative">
                        <b-avatar variant="primary" class="mr-2" size="40px" :src="message.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(message.message_participant.participant_fullname)"></b-avatar>
                        <b-row>
                            <b-col cols="12" class="d-flex align-items-center name">
                                <p class="mb-0 font-weight-500 mr-1">{{ message.message_participant.participant_fullname }}</p>
                            </b-col>
                            <b-col cols="12" class="message">
                                <RichTextRenderer :content="message.message_content" />
                            </b-col>
                            <div class="position-absolute top-0" style="right: 8px">
                                {{ message.message_created_date | dateTimeDynamicFormat('DD/MM/YYYY h:mm A') }}
                                <el-dropdown :tabindex="message.message_id" class="py-2 ml-2 cursor-pointer" trigger="click" v-if="_gAuth.activeUserId() === message.message_participant.participant_user_id">
                                    <b class="el-dropdown-link">
                                        <b-icon icon="three-dots-vertical">
                                        </b-icon>
                                    </b>
                                    <el-dropdown-menu slot="dropdown" @click.native.stop="editMessage(message)">
                                        <el-dropdown-item class="d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 512 512"><path fill="#293854" d="m362.7 19.3-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L151 475.7c14.1-4.2 27-11.8 37.4-22.2l233.3-233.2-130-130z"/></svg>
                                            Edit
                                        </el-dropdown-item>
                                        <el-dropdown-item class="text-danger d-flex align-items-center" @click.native.stop="deleteMessage(message.message_id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 448 512"><path fill="currentColor" d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/></svg>
                                            Delete
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </b-row>    
                    </div>

                    <!-- Replies -->
                    <div class="d-flex align-items-start replies px-3">
                        <b-avatar variant="primary" class="mr-2 invisible" style="width: 40px; height: 20px;" :src="message.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(message.message_participant.participant_fullname)"></b-avatar>
                        <b-row>
                                <b-col cols="12" class="text-muted cursor-pointer pl-0" @click="replyMessage(message)" v-if="!isReadonly">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" class="mr-1" viewBox="0 0 512 512"><path fill="#73839C" d="M205 34.8c11.5 5.1 19 16.6 19 29.2v64h112c97.2 0 176 78.8 176 176 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96h-96v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"/></svg>
                                        <span class="text-xs">Reply</span>
                                </b-col>
                                <b-col cols="12" class="pl-0" v-if="message.message_reply_items.length > 0">
                                        <div class="text-danger cursor-pointer" v-b-toggle="`collapse-${message.message_id}`">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                                                <span class="text-xs">Replies</span>
                                        </div>
                                </b-col>
                        </b-row>
                    </div>

                    <b-row no-gutters v-if="message.message_reply_items.length > 0">
                        <b-col cols="11" offset="1" class="replies-messages">
                            <b-collapse :id="`collapse-${message.message_id}`" class="my-2">
                                <div v-for="(reply, index) in sortedReplies(message.message_reply_items)" :key="index">
                                    <div class="border-bottom py-2">
                                        <div class="d-flex align-items-start position-relative">
                                            <b-avatar variant="primary" class="mr-2" size="30px" :src="reply.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(reply.message_participant.participant_fullname)"></b-avatar>
                                            <b-row>
                                                <b-col cols="12" class="d-flex align-items-center name">
                                                    <p class="mb-0 font-weight-500 text-xs mr-1">{{ reply.message_participant.participant_fullname }}</p>
                                                </b-col>
                                                <b-col cols="12" class="message">
                                                    <RichTextRenderer :content="reply.message_content" />
                                                </b-col>
                                                <div class="position-absolute top-0 text-xs" style="right: 8px">
                                                    {{ reply.message_created_date | dateTimeDynamicFormat('DD/MM/YYYY h:mm A') }}
                                                    <el-dropdown :tabindex="reply.message_id" class="py-2 ml-2 cursor-pointer" trigger="click" v-if="_gAuth.activeUserId() === reply.message_participant.participant_user_id">
                                                        <b class="el-dropdown-link">
                                                            <b-icon icon="three-dots-vertical">
                                                            </b-icon>
                                                        </b>
                                                        <el-dropdown-menu slot="dropdown">
                                                            <el-dropdown-item @click.native.stop="editMessage(reply)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 512 512"><path fill="#293854" d="m362.7 19.3-48.4 48.4 130 130 48.4-48.4c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2c-2.5 8.5-.2 17.6 6 23.8s15.3 8.5 23.7 6.1L151 475.7c14.1-4.2 27-11.8 37.4-22.2l233.3-233.2-130-130z"/></svg>
                                                                Edit
                                                            </el-dropdown-item>
                                                            <el-dropdown-item class="text-danger" @click.native.stop="deleteMessage(reply.message_id)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 448 512"><path fill="currentColor" d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"/></svg>
                                                                Delete
                                                            </el-dropdown-item>
                                                        </el-dropdown-menu>
                                                    </el-dropdown>
                                                </div>
                                            </b-row>    
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-col>
                    </b-row>
                </div>
                <div class="border-top px-3 py-2" v-else>
                    <div class="messenger-header position-relative text-center">
                        <small><i v-html="message.message_content"></i></small>
                    </div>
                </div>
            </div>
            <b-row>
                <b-col cols="6" class="d-flex justify-content-end mt-3 mb-5">
                    <b-button variant="outline-primary" @click="loadMoreMessages" v-if="!disableLoadViewMore">Load More</b-button>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-start mt-3 mb-5">
                    <b-button variant="outline-primary" @click="viewAllMessages" v-if="!disableLoadViewMore">View All</b-button>
                </b-col>
            </b-row>
        </div>

        <!-- Drawer for Search Message -->
        <search-message-drawer ref="search_message_drawer"></search-message-drawer>
    </div>
</template>
<script>
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import  { Dropdown, DropdownMenu, DropdownItem, Tooltip, Button, Popover } from 'element-ui'
import Tiptap from '@/components/TipTap/Tiptap'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { useConfigStore } from '@/stores/configStore'
import RichTextRenderer from '@/views/Messaging/Chats/RichTextRenderer'
import SearchMessageDrawer from '@/views/Messaging/SearchMessageDrawer'
import {axios, services, getHeader, swal} from '@/assets/js/httpImports.js'
import { CAN_ASSIGN_ROLE_IDS } from '@/assets/js/roles.js' 

export default {
    props: {
        showCreatNewGroup: Boolean,
        showMainPage: Boolean,
        showChatRooms: Boolean,
        value: {
            type: String,
            default: '',
        },
    },
    components: {
        Tiptap,
        RichTextRenderer,
        SearchMessageDrawer,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Tooltip.name]: Tooltip,
        [Popover.name]: Popover,
        [Button.name]: Button
    },
    data() {
        return {
            content: '',
            CAN_ASSIGN_ROLE_IDS: CAN_ASSIGN_ROLE_IDS
        }
    },
    computed: {
        ...mapState(useMessagingStore,['messages', 'selected_group', 'replying_to', 'messages_pagination', 'messages_length' ,'message_profile']),
        ...mapState(useConfigStore,['app_code']),
        disableLoadMore() {
            return !_gHlp.isEmpty(this.messages_pagination) ? (Number(this.messages_pagination.current_page) >= (Number(this.messages_pagination.total))) : true;
        },
        disableLoadViewMore() {
            return this.messages.length == this.messages_length ? true : false
        },
        isReadonly(){
            if(_gHlp.isEmpty(this.selected_group)) return true;
            return _gHlp.isEmpty(this.selected_group.group_participants.find(o => o.participant_user_id == _gAuth.activeUserId()))
        },
    },
		create(){
			this.resetMessages()
			this.content = ''
		},
		beforeUnmount(){
			this.resetMessages()
			this.content = ''
		},
		watch: {
			message_profile:{
				handler: function (newVal) {
					if(_gHlp.isEmpty(newVal)){
						this.content = ''
					}
				},
				immediate: true
			}
    },
    methods: {
        ...mapActions(useMessagingStore,['resetMessages', 'getGroupName', 'getGroupCreator', 'getGroupMessageList', 'updateLoadingMessage', 'getMessages', 'setReplyTo', 'resetReplyTo', 'getMoreMessages', 'setEditMessage', 'refreshMessageBox']),
        emitEvent(eventName) {
            chatEventBus.$emit(eventName)
            if (eventName === 'go-back-to-chat-main') {
                this.updateLoadingMessage(true)
                this.getGroupMessageList(this.message_profile.message_group_bundle_key).then(resp => {
                    this.resetMessages()
                    this.content = ''
                    this.updateLoadingMessage(false)
                });
            }
        },
        deleteMessage(message_id) {
            swal.fire({
                title: 'Are you sure?',
                text: "Message will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    axios.post(services.messaging + 'message/delete/' + message_id, null, { headers: getHeader() })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.$notify({
                                message:
                                    '<b>Message :</b> - Successfully Deleted.',
                                timeout: 10000,
                                icon: 'ni ni-bell-55',
                                type: 'default',
                            });

                            this.getMessages(this.selected_group.group_id)
                            this.refreshMessageBox(this.message_profile.message_group_bundle_key)
                            this.content = ''
                        }
                    })
                    .catch ( error => {
                        _gNotif.cLog('Error:', error)
                        _gNotif.errorFunction(error)
                    });
                } 
            })
        },
        replyMessage(message) {
            this.setReplyTo(message)
        },
        resetReply() {
            this.resetReplyTo()
        },
        editMessage(message) {
            this.resetReplyTo()
            this.setEditMessage(message)
        },
        loadMoreMessages() {
            this.getMoreMessages()
        },
        viewAllMessages() {
            this.getMessages(this.selected_group.group_id, this.messages_length)
        },
        sortedReplies(replies) {
            return [...replies].sort((a, b) => 
                new Date(b.message_created_date) - new Date(a.message_created_date)
            )
        },
    },
}
</script>